import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  UpdateRetroDiscountsMutation,
  UpdateRetroDiscountsMutationVariables
} from './__generated__/UpdateRetroDiscountsMutation';

export const UPDATE_RETRO_DISCOUNTS_MUTATION = gql`
  mutation UpdateRetroDiscountsMutation($campaignId: ID!, $retroDiscountsInput: [RetroDiscountsInput!]!) {
    updateRetroDiscounts(campaignId: $campaignId, retroDiscountsInput: $retroDiscountsInput) {
      success
      errors
    }
  }
`;

export const useUpdateRetroDiscountsMutation = () => {
  return useMutation<UpdateRetroDiscountsMutation, UpdateRetroDiscountsMutationVariables>(
    UPDATE_RETRO_DISCOUNTS_MUTATION,
    {
      client: kmsClient
    }
  );
};
